export const SHOW_PANEL = {
  showPanel: {
    values: [
      {
        provider: 'self',
        property: 'hidePanelWhenItHasNoDataToShow',
      },
      {
        provider: 'self',
        property: 'productData',
        startWith: {
          value: undefined,
        },
      },
    ],
    transform: function ([hidePanelWhenItHasNoDataToShow, productData]: [
      boolean,
      unknown[],
    ]): boolean {
      const hasData = !!productData && productData.length > 0;
      return hasData || !hidePanelWhenItHasNoDataToShow;
    }.toString(),
  },
};
